// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Instagram: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
            <g fill="none" fillRule="evenodd" stroke="#FFF">
                <rect width="31" height="31" x=".5" y=".5" opacity=".33" />
                <path
                    fill="#FFF"
                    fillRule="nonzero"
                    strokeWidth=".5"
                    d="M12.172391,15.9966975 C12.172391,13.8830911 13.8896962,12.165786 16.0033025,12.165786 C18.1169089,12.165786 19.834214,13.8830911 19.834214,15.9966975 C19.834214,18.1103038 18.1169089,19.827609 16.0033025,19.827609 C13.8896962,19.827609 12.172391,18.1103038 12.172391,15.9966975 M19.9597094,8.5 L12.0468956,8.5 C10.0984148,8.5 8.5,10.0984148 8.5,12.0468956 L8.5,19.9531044 C8.5,21.9081902 10.0984148,23.5 12.0468956,23.5 L19.9531044,23.5 C21.9081902,23.5 23.5,21.9081902 23.5,19.9531044 L23.5,12.0402906 C23.5,10.0918098 21.9081902,8.5 19.9597094,8.5 M12.0468956,9.38507266 L19.9531044,9.38507266 C21.4194188,9.38507266 22.6149273,10.5805812 22.6149273,12.0468956 L22.6149273,19.9531044 C22.6149273,21.4194188 21.4194188,22.6149273 19.9531044,22.6149273 L12.0468956,22.6149273 C10.5871863,22.6149273 9.38507266,21.4194188 9.38507266,19.9531044 L9.38507266,12.0402906 C9.39167768,10.5805812 10.5871863,9.38507266 12.0468956,9.38507266 M20.7457067,10.501321 C20.3163804,10.501321 19.9663144,10.8513871 19.9663144,11.2807133 C19.9663144,11.7100396 20.3097754,12.0601057 20.7457067,12.0601057 C21.175033,12.0601057 21.5250991,11.7166446 21.5250991,11.2807133 C21.5250991,10.8513871 21.175033,10.501321 20.7457067,10.501321 M20.838177,15.9966975 C20.838177,13.3216645 18.6717305,11.161823 16.0033025,11.161823 C13.3282695,11.161823 11.168428,13.3282695 11.168428,15.9966975 C11.168428,18.6717305 13.3348745,20.831572 16.0033025,20.831572 C18.6783355,20.831572 20.838177,18.6717305 20.838177,15.9966975"
                />
            </g>
        </svg>
    );
};

export default React.memo(Instagram);
